import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Modal = ({ classes, className, isOpen, onClose, children }) => {
  if (!isOpen) return null

  return (
    <div className={classes.wrapper}>
      <div className={classes.modal}>
        <div className={classNames(className, classes.content)}>{children}</div>
      </div>
      <div className={classes.backdrop} onClick={onClose} />
    </div>
  )
}

Modal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    backdrop: PropTypes.string,
    modal: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node,
}

Modal.defaultProps = {
  className: '',
  onClose: undefined,
  children: undefined,
}

export default Modal
